import { FlexBox, JoonUIColor, SPACING, Shadow } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import NavLink from "./NavLink"
import useIsCoachingAvailable from "../../hooks/useIsCoachingAvailable"
import useCareTeam from "../../pages/care/useCareTeam"
import GetStartedSection from "../getStarted/GetStartedSection"
import CareIcon from "../icons/CareIcon"
import FamilyIcon from "../icons/FamilyIcon"
import MeIcon from "../icons/MeIcon"
import QuestsIcon from "../icons/QuestsIcon"
import RewardsIcon from "../icons/RewardsIcon"
import SettingsIcon from "../icons/SettingsIcon"

const Sidebar = () => {
  const { hasTherapist, hasCoach, isLoading } = useCareTeam()
  const location = useLocation()
  const { t } = useTranslation()
  const isCoachingAvailable = useIsCoachingAvailable()

  // With no care team yet, the tab is purely a coaching upsell — so it's hidden
  // outright for users who can't buy a coach. Anyone already working with a
  // therapist or coach keeps it regardless of language.
  const showCareTab = hasTherapist || hasCoach || isCoachingAvailable

  if (
    location.pathname === "/subscription-cancel" ||
    location.pathname === "/checkout" ||
    location.pathname === "/referral-landing" ||
    isLoading
  )
    return <></>

  return (
    <div className={"nav-wrapper"}>
      <div
        style={{
          height: "100dvh",
          background: "white",
          position: "fixed",
          zIndex: "1000",
          boxShadow: Shadow.high,
          borderRight: `1px solid ${JoonUIColor.border.default}`,
          display: "flex",
          flexDirection: "column",
          borderRadius: "0 8px 8px 0",
          justifyContent: "space-between",
          overflowY: "auto",
          scrollbarWidth: "none",
        }}
        className={"nav"}
      >
        <FlexBox direction="column" gap={SPACING.space4}>
          <div style={{ padding: SPACING.space2, position: "relative" }}>
            <img
              src="/images/logos/logo_white.svg"
              alt="Joon"
              style={{
                height: SPACING.space11,
                margin: "1.5rem 1rem 0rem 1rem",
              }}
            />
          </div>
          <FlexBox direction="column" gap={SPACING.space2}>
            <NavLink to="/me" name={t("NAV_ME")} Icon={MeIcon} />
            {showCareTab && (
              <NavLink
                to="/care"
                name={hasTherapist ? t("NAV_CARE") : t("NAV_COACH")}
                Icon={CareIcon}
              />
            )}
            <NavLink to="/quests" name={t("NAV_QUESTS")} Icon={QuestsIcon} />
            <NavLink to="/rewards" name={t("NAV_REWARDS")} Icon={RewardsIcon} />
            <NavLink to="/family" name={t("NAV_FAMILY")} Icon={FamilyIcon} />
            <FlexBox
              align="center"
              style={{ padding: SPACING.space6, height: "14px" }}
            >
              <div
                style={{
                  width: "100%",
                  borderBottom: `1px solid ${JoonUIColor.border.default}`,
                }}
              />
            </FlexBox>

            <NavLink
              to="/settings"
              name={t("NAV_SETTINGS")}
              Icon={SettingsIcon}
            />
          </FlexBox>
          <div className="p-4 w-full">
            <GetStartedSection isOnNav />
          </div>
        </FlexBox>
      </div>
    </div>
  )
}

export default Sidebar
